import * as yup from "yup";

export const schema = yup.object().shape({
  newPassword: yup
    .string()
    // .required()
    .min(8, "Your password must be at least 8 characters long.")
    .matches(
      /(?=.*?[0-9])(?=.*?[A-Za-z]).+/,
      "Your password must contain at least 1 digit (0-9) and at least one letter."
    ),
});
